/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { IconButton } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

export const StyledIconButton = styled(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ left, right, ...props }: { left?: boolean; right?: boolean } & any) => (
    <IconButton {...props} />
  ),
  // purposely exclude left & right props to avoid Material errors
)<{ theme: ICustomTheme; left?: boolean; right?: boolean }>(
  ({ theme, left = false, right = false }) => ({
    backgroundColor: theme.colors.black.dark3,
    borderRadius: theme.shape.borderRadius * 10,
    color: theme.colors.white,
    left: left ? theme.spacing(8) : 'unset',
    padding: theme.spacing(1),
    position: 'absolute',
    right: right ? theme.spacing(8) : 'unset',
    top: '45%',
    transition: theme.transitions.create(['background-color', 'color']),
    zIndex: 1,
    opacity: 0,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      color: theme.colors.black.dark1,
    },
  }),
);

export const StyledIndicator = styled.li<{
  theme: ICustomTheme;
  isSelected: boolean;
}>(({ theme, isSelected }) => ({
  backgroundColor: theme.colors.black.dark3,
  borderRadius: '100%',
  cursor: isSelected ? 'default' : 'pointer',
  display: 'inline-block',
  height: theme.spacing(1.25),
  margin: theme.spacing(0, 0.75, 2),
  opacity: isSelected ? 1 : 0.5,
  transition: theme.transitions.create(['opacity', 'background-color']),
  width: theme.spacing(1.25),
  ...(isSelected
    ? {}
    : {
        '&:hover': {
          backgroundColor: theme.colors.black.dark1,
        },
      }),
}));

export const cssContainer = (
  theme: ICustomTheme,
  isMobile: boolean,
  isFromWidgetGlobalView: boolean,
) => ({
  margin: theme.spacing(-1, -1.5),

  '& .carousel': {
    display: 'flex' as const,
    flexDirection: 'column' as const,
  },

  '& .slider-wrapper': {
    order: 0,
    minHeight: isMobile ? 100 : 200,
    paddingBottom: 16,
  },

  '& .control-dots': {
    order: 1,
    position: 'relative' as const,
    bottom: 0,
    padding: 0,
    width: '100%',
    ...(isMobile ? { zIndex: 0 } : {}),
  },

  '& .slide': {
    background: 'none',
    display: 'flex' as const,
    flexDirection: 'column' as const,
    justifyContent: isFromWidgetGlobalView ? 'flex-start' : 'center' as const,
    alignItems: 'stretch' as const,
  },

  '&:hover': {
    '.MuiButtonBase-root': {
      opacity: 1,
    },
  },
});

export const cssGrouped = (theme: ICustomTheme) => ({
  padding: theme.spacing(0, 5),
});

export const cssContainerGrouped = (
  theme: ICustomTheme,
  isMobile: boolean,
  isFromWidgetGlobalView: boolean,
) => [cssContainer(theme, isMobile, isFromWidgetGlobalView), cssGrouped(theme)];

export const cssLargeIcon = { fontSize: '3rem' };

export const cssMessage = css({
  paddingTop: '15%',
  textAlign: 'center',
  width: '100%',
});
